
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/court/[venueSlug]",
      function () {
        return require("private-next-pages/court/[venueSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/court/[venueSlug]"])
      });
    }
  